module.exports = __webpack_public_path__ + "img/充电枪.10ecc740.png";